import React, {
  createContext, useContext, useState, ReactNode,
  useMemo,
} from 'react';

type ProgressStatusMap = Record<string, boolean>;

interface ProgressStatusContextType {
  progress: ProgressStatusMap;
  setInProgress: (key: string, value: boolean) => void;
  isInProgress: (key: string) => boolean;
}

const defaultProgressStatusContext: ProgressStatusContextType = {
  progress: {},
  setInProgress: () => { },
  isInProgress: () => false,
};

const ProgressStatusContext = createContext<ProgressStatusContextType>(defaultProgressStatusContext);

export function ProgressStatusProvider({ children }: { children: ReactNode }) {
  const [progress, setProgress] = useState<ProgressStatusMap>({});

  const setInProgress = (key: string, value: boolean) => {
    setProgress((prev) => ({ ...prev, [key]: value }));
  };

  const isInProgress = (key: string) => !!progress[key];

  const contextValue = useMemo(() => ({ progress, setInProgress, isInProgress }), [progress, setInProgress, isInProgress]);

  return (
    <ProgressStatusContext.Provider value={contextValue}>
      {children}
    </ProgressStatusContext.Provider>
  );
}

export const useProgressStatusContext = (): ProgressStatusContextType => useContext(ProgressStatusContext);

export const useProgressStatusByInitiator = (initiator: string): boolean => {
  const { isInProgress } = useProgressStatusContext();
  return isInProgress(initiator);
};
